import { GiftCardsApiClient } from '@fourthwall/services/dist/GiftCardsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiftCardTimelineQuery = createQueryHook(GiftCardsApiClient.getGiftCardTimeline, {
  queryKey: ['giftCardTimeline'],
})
